import _ from 'lodash';
import config from '../package.json';

export const getCachedHealthKeeperTokenExpireTime = (state: any) => {
  return _.get(
    state,
    `hk-emma-web-core/${config.id}.healthKeeper.token.expireTime`,
  );
};

export const getCachedHealthKeeperToken = (state: any) => {
  return _.get(
    state,
    `hk-emma-web-core/${config.id}.healthKeeper.token.accessToken`,
  );
};

export const getHealthKeeperDialogState = (state: any) => {
  return _.get(
    state,
    `hk-emma-web-core/${config.id}.healthKeeper.isShowHealthKeeperModal`,
    false,
  );
};
